import React from "react";
import ParentTrack from "./ParentTrack";
import { selectTracks, selectStackedEventsForDayRange } from "../redux/selectors";
import { connect } from "react-redux";
import "./TracksView.css";

class TracksView extends React.Component {
    render() {
        if (this.props.tracks === false) {
            return null;
        }
        return (
            <React.Fragment>
                {this.props.tracks.map((track, i) => {
                    return (
                        <ParentTrack
                            key={i}
                            track={track}
                            index={i}
                            events={this.props.events[i]}
                        />
                    );
                })}
            </React.Fragment>
        );
    }
}

export default connect(
    store => {
        return {
            tracks: selectTracks(store),
            events: selectStackedEventsForDayRange(store)
        };
    },
    {}
)(TracksView);
